module.exports = () => require('./multi-byte.encodings.json') // lazy-load
